module.exports = __webpack_public_path__ + "static/media/tooltips_d_021.movie.532fa521.mp4";